import { useEffect, useRef } from 'react';

import * as Sentry from '@sentry/react';
import cookie from 'cookie';

import { intercomBoot, intercomShutdown } from '@App/intercom/intercom';
import Providers from '@App/providers';
import ScrollToTop from '@App/utils/ScrollToTop';
import { getEmailFromUrl } from '@Shared/helpers';

import Routing from './ui/Routing';
import './ui/styles/output.css';

import '@selina-finance/ui/build/fonts.css';

function App() {
    const mounted = useRef(false);

    useEffect(() => {
        // set cookie if email and applicationId are present in the URL
        // handles case with + in email
        const emailAddress = getEmailFromUrl(window.location.search);
        const urlParams = new URLSearchParams(window.location.search);
        const applicationId = urlParams.get('applicationId') || '';

        const cookieData = {
            applicationId,
            emailAddress,
        };

        if (emailAddress && applicationId) {
            document.cookie = cookie.serialize(
                'application',
                JSON.stringify(cookieData),
                {
                    path: '/',
                    domain: window._env_.SELINA_DOMAIN,
                },
            );
        }

        if (!mounted.current) {
            try {
                intercomBoot();
            } catch (e) {
                console.error('unsupported browser');
            }
            mounted.current = true;
        }
        return () => intercomShutdown();
    }, []);

    return (
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Providers>
                <ScrollToTop>
                    <Routing />
                </ScrollToTop>
            </Providers>
        </Sentry.ErrorBoundary>
    );
}

export default App;
